<template>
  <b-container id="customized-speaking">
    <b-row>
      <b-col>
        <h3>TorchMetrics is your online presentation coach ready for you!</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="4" class="mb-4 mb-lg-0">
        <div class="customized-speaking-box text-center">
          <img src="/img/icons/marketing-2.png" />
          <h3>Get Feedback</h3>
          <p>
            <b>Anonymous surveys</b> deliver honest feedback to help you
            understand your unique strengths and challenges as a presenter.
          </p>
        </div>
      </b-col>
      <b-col sm="12" lg="4" class="mb-4 mb-lg-0">
        <div class="customized-speaking-box text-center">
          <img src="/img/icons/wealth-1.png" />
          <h3>Take Action</h3>
          <p>
            <b>Customized action</b> in a variety of engaging formats help
            you boost your skills and crush your weaknesses.
          </p>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="customized-speaking-box text-center">
          <img src="/img/icons/report-4.png" />
          <h3>Track Your Progress</h3>
          <p>
            The <b>progress dashboard</b> gives you metrics to track your
            improvement from one presentation to the next.
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="learn-more">
        <TMGeneralButton
          text="LEARN MORE"
          route="HowItWorks"
          className="blue"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
export default {
  name: "CustomizedSpeakingCoach",
  components: {
    TMGeneralButton,
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/components/home/CustomizedSpeakingCoach.less";
</style>